import { useState, useEffect } from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="terms-page">
      <header className="sticky top-0 z-50 glass border-b border-[#2D231E]/10">
        <div className="container-max flex items-center h-16">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#5C4D43] hover:text-[#C44536] transition-colors" data-testid="back-from-terms">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-sans text-sm font-medium">Volver</span>
          </button>
        </div>
      </header>

      <div className="container-max py-12 max-w-4xl">
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-8 h-8 text-[#C44536]" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2D231E]">Terminos y Condiciones</h1>
        </div>

        <div className="prose prose-lg font-sans text-[#2D231E] space-y-6">
          <p className="text-[#5C4D43] text-sm">Ultima actualizacion: Abril 2026</p>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">1. Identificacion</h2>
            <p className="text-[#5C4D43]">
              <strong>Talwinder Singh Kaur</strong> (empresaria autonoma)<br />
              Nombre comercial: Taj Mahal San Fernando<br />
              NIF: 78317925G<br />
              Calle Real 109, San Fernando, Cadiz 11100, España<br />
              Email: Tajmahalsafernando@gmail.com<br />
              Telefono: +34 602 704 745 / +34 856 044 420
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">2. Objeto</h2>
            <p className="text-[#5C4D43]">
              Los presentes terminos y condiciones regulan el uso del sitio web y el servicio de pedidos online de comida para recogida y entrega a domicilio ofrecido por Taj Mahal San Fernando.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">3. Pedidos</h2>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-2">
              <li>Los pedidos se realizan a traves de nuestra pagina web o via WhatsApp.</li>
              <li>Todos los pedidos requieren pago previo online.</li>
              <li>El tiempo estimado de entrega es de aproximadamente <strong>50 minutos</strong>.</li>
              <li>El tiempo estimado de recogida es de aproximadamente <strong>20 minutos</strong>.</li>
              <li>Los tiempos son estimados y pueden variar segun la demanda.</li>
              <li>Nos reservamos el derecho de rechazar pedidos si no podemos garantizar la calidad del servicio.</li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">4. Precios e Impuestos</h2>
            <p className="text-[#5C4D43]">
              Todos los precios mostrados en la web incluyen el IVA aplicable. Los precios pueden ser modificados sin previo aviso, pero siempre se aplicara el precio vigente en el momento de la realizacion del pedido.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">5. Metodos de Pago</h2>
            <p className="text-[#5C4D43]">
              Aceptamos pagos mediante tarjeta de credito/debito a traves de pasarelas de pago seguras (Stripe/Redsys) que cumplen con la normativa PCI DSS. No almacenamos datos de tarjetas de credito en nuestros servidores.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">6. Zona de Entrega</h2>
            <p className="text-[#5C4D43]">
              El servicio de entrega a domicilio esta disponible en San Fernando y zonas cercanas. Si su direccion esta fuera de nuestra zona de cobertura, le informaremos y podra optar por la recogida en el restaurante.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">7. Cancelaciones, Reembolsos y Politica de Devolucion</h2>
            <ul className="list-disc pl-6 text-[#5C4D43] space-y-2">
              <li><strong>Cancelacion por el cliente (primeros 5 minutos):</strong> El cliente puede cancelar su pedido de forma gratuita dentro de los 5 minutos siguientes a la realizacion del mismo. El reembolso se procesara automaticamente al metodo de pago original.</li>
              <li><strong>Despues de 5 minutos:</strong> Una vez transcurridos 5 minutos, el pedido no puede cancelarse online. El cliente debera contactar directamente con el restaurante llamando al +34 602 704 745 para solicitar la cancelacion.</li>
              <li><strong>Aceptacion del pedido:</strong> Todos los pedidos deben ser aceptados por el restaurante en un plazo de 5 minutos. Si el restaurante no acepta el pedido dentro de este plazo, el pedido se cancelara automaticamente y el reembolso se procesara de forma inmediata.</li>
              <li><strong>Cancelacion por el restaurante:</strong> El restaurante se reserva el derecho de cancelar un pedido en cualquier momento. En caso de cancelacion por parte del restaurante, el reembolso completo se procesara automaticamente.</li>
              <li><strong>Plazo de reembolso:</strong> Los reembolsos se procesan automaticamente y pueden tardar entre 5 y 10 dias habiles en reflejarse en su cuenta, dependiendo de su entidad bancaria.</li>
              <li><strong>Pedidos incorrectos o en mal estado:</strong> Si recibe un pedido incorrecto o en mal estado, contacte con nosotros dentro de las <strong>2 horas</strong> siguientes a la recepcion al +34 602 704 745 o por email a Tajmahalsafernando@gmail.com para gestionar un reembolso o reposicion. Pasado ese plazo no podremos garantizar la trazabilidad ni el estado original del producto, por lo que no se aceptaran reclamaciones de calidad.</li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">8. Alergenos e Intolerancias Alimentarias</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              En cumplimiento del <strong>Reglamento (UE) 1169/2011</strong> y del Real Decreto 126/2015, sobre informacion alimentaria al consumidor, ponemos a disposicion del cliente la informacion sobre los <strong>14 alergenos</strong> de declaracion obligatoria presentes en nuestros platos. Esta informacion esta disponible:
            </p>
            <ul className="list-disc pl-6 text-[#5C4D43] mt-2 space-y-1">
              <li>En el establecimiento, solicitandola al personal antes de pedir.</li>
              <li>Por telefono / WhatsApp al <strong>+34 602 704 745</strong> antes de hacer el pedido.</li>
              <li>Por email a <strong>Tajmahalsafernando@gmail.com</strong>.</li>
            </ul>

            <p className="text-[#5C4D43] leading-relaxed mt-4">
              <strong>Riesgo de contaminacion cruzada.</strong> Nuestra cocina manipula a diario los siguientes alergenos: gluten, lacteos, frutos secos, cacahuetes, sesamo, soja, mostaza, huevo, pescado, crustaceos, moluscos, apio, sulfitos y altramuces. Aunque extremamos las precauciones, <strong>no podemos garantizar la ausencia total de trazas</strong> de ningun alergeno en nuestros platos debido al uso compartido de utensilios, superficies y aceites de freir. Por este motivo, los platos no pueden considerarse aptos para personas con alergias graves o anafilacticas a ninguno de estos ingredientes.
            </p>

            <p className="text-[#5C4D43] leading-relaxed mt-3">
              <strong>Responsabilidad del cliente.</strong> El cliente con cualquier alergia, intolerancia o condicion medica relacionada con la alimentacion (por ejemplo celiaquia) tiene la <strong>obligacion de informarnos antes de realizar el pedido</strong>, ya sea por telefono, WhatsApp o en el campo "Notas" del checkout, indicando claramente el alergeno. Sin esa comunicacion previa, el restaurante no puede valorar la idoneidad del plato y el cliente <strong>asume el riesgo</strong> derivado del consumo. Si su alergia es severa, recomendamos pedir confirmacion expresa por escrito antes de consumir el producto.
            </p>

            <p className="text-[#5C4D43] leading-relaxed mt-3">
              <strong>Limitacion de responsabilidad.</strong> Una vez informados, haremos cuanto este razonablemente en nuestra mano para preparar el plato evitando el alergeno indicado, pero, dado el riesgo de contaminacion cruzada inherente a una cocina comercial, no asumiremos responsabilidad por reacciones adversas cuando: (i) el cliente no haya informado previamente del alergeno, (ii) la informacion proporcionada haya sido incompleta o inexacta, o (iii) el plato consumido sea distinto al pactado tras la comunicacion.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">9. Propiedad Intelectual</h2>
            <p className="text-[#5C4D43]">
              Todo el contenido de este sitio web (textos, imagenes, logotipos, diseño) es propiedad de Taj Mahal San Fernando y esta protegido por las leyes de propiedad intelectual.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">10. Legislacion Aplicable</h2>
            <p className="text-[#5C4D43]">
              Estos terminos se rigen por la legislacion española. Para cualquier controversia, las partes se someten a los juzgados y tribunales de Cadiz, España.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
